<template>
  <div class="sign">
    <div class="name" @click="changeName">
      <span>{{ traderName }}</span>
      <van-icon class="icon" name="play" />
    </div>
    <div class="notice">
      <van-icon name="warning" />
      <span>为了确保您的身份真实性，请先进行证书申请</span>
    </div>
    <div class="info">
      <van-cell-group inset>
        <van-cell title="姓名" :value="userInfo.name" />
        <van-cell title="身份证号" :value="userInfo.idNo" />
        <van-cell title="手机号" :value="userInfo.mobile" />
        <van-cell title="认证身份" value="印章管理员" />
        <van-cell title="状态">
          <span v-if="signStatus == 0" style="color: red">未认证</span>
          <span v-else>已完成认证</span>
        </van-cell>
      </van-cell-group>
    </div>
    <div v-if="signStatus == 0" class="submit-btn" @click="handleSign">
      去申请证书
    </div>
    <div v-else class="submit-btn" @click="handleAgreement">去查看合同</div>
  </div>
</template>

<script>
import { Dialog } from 'vant';
import {
  ApiGetSealUser,
  ApiGetSealStatus,
  ApiGetCloudCertUrl,
} from '@/api/dq.js';
const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    'micromessenger'
  );
};
export default {
  data() {
    return {
      userInfo: {},
      signStatus: 1,
      traderId: 0,
      traderName: 0,
    };
  },
  computed: {
    type() {
      return this.$route.query.type
    }
  },
  methods: {
    getUserInfo() {
      let data = {
        traderId: this.traderId,
        type: 1,
      };
      ApiGetSealUser(data).then((res) => {
        this.userInfo = res[0];
      });
    },
    getSealStatus() {
      let data = {
        traderId: this.traderId,
      };
      ApiGetSealStatus(data).then((res) => {
        // this.signStatus = res.data
        // 0未申请   1 已申请
        this.signStatus = res.data;
        if (res.data == 1) {
          this.handleAgreement()
        }
      });
    },
    changeName() {
      this.$router.push({
        path: '/dq/business_choice',
      });
    },
    handleSign() {
      // 跳转第三方
      let data = {
        type: 1,
        traderId: this.traderId,
      };
      ApiGetCloudCertUrl(data).then((href) => {
        Dialog.confirm({
          title: '证书申请',
          message: '您是否现在跳转到外部链接进行证书申请?',
        }).then(() => {
          if (isWechat()) {
            this.$router.push({
              path: '/dq/guide',
              query: {
                path: href,
              },
            });
          } else {
            this.$router.push({
              path: '/dq/guide_phone',
              query: {
                path: href,
              },
            });
          }
        });
      });
    },
    handleAgreement() {
      this.$router.replace({
        path: '/dq/agreementList',
        query: {
          traderId: this.traderId,
          traderName: this.traderName,
          type: this.type,
        },
      });
    },
  },
  mounted() {
    this.traderId = this.$route.query.traderId;
    this.traderName = this.$route.query.traderName;
    this.getUserInfo();
    this.getSealStatus();
  },
};
</script>

<style lang="less" scoped>
.sign {
  line-height: 1;
  font-size: 16px;
  background: #f3f5f6;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #111111;
  text-align: left;

  .name {
    padding: 16px 24px;
    display: flex;
    align-items: center;
    background: #fff;
  }

  .notice {
    padding: 16px 24px;
    background: #fdf6e9;
    font-size: 14px;
    font-weight: 500;
    color: #fc9127;
    display: flex;
    align-items: center;
  }

  .info {
    margin-top: 20px;

    .van-cell__title {
      color: #666666;
    }

    .van-cell__value {
      flex: 2;
      text-align: left;
      color: #111111;
    }
  }
}

.icon {
  transform: rotateZ(90deg) scale(0.8);
}

.submit-btn {
  width: 232px;
  text-align: center;
  height: 44px;
  line-height: 44px;
  background: #FF6F00;
  border-radius: 22px;
  color: #fff;
  margin: 40px auto;
}</style>